/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Plan_ComposeInputs */

const en_inbox_na_plan_compose = /** @type {(inputs: Inbox_Na_Plan_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compose the steps`)
};

const id_inbox_na_plan_compose = /** @type {(inputs: Inbox_Na_Plan_ComposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susun langkah`)
};

/**
* | output |
* | --- |
* | "Compose the steps" |
*
* @param {Inbox_Na_Plan_ComposeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_plan_compose = /** @type {((inputs?: Inbox_Na_Plan_ComposeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Plan_ComposeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_plan_compose(inputs)
	return en_inbox_na_plan_compose(inputs)
});